import { render, staticRenderFns } from "./BundleInfo.vue?vue&type=template&id=0540459a&scoped=true&"
import script from "./BundleInfo.vue?vue&type=script&lang=js&"
export * from "./BundleInfo.vue?vue&type=script&lang=js&"
import style0 from "./BundleInfo.vue?vue&type=style&index=0&id=0540459a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540459a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0540459a')) {
      api.createRecord('0540459a', component.options)
    } else {
      api.reload('0540459a', component.options)
    }
    module.hot.accept("./BundleInfo.vue?vue&type=template&id=0540459a&scoped=true&", function () {
      api.rerender('0540459a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/detail/BundleInfo.vue"
export default component.exports